export default "__VITE_PUBLIC_ASSET__224841a1__"